'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useOldAbTests } from '@/hooks/useOldAbTests';
import { useAbTestConfig } from '@/atoms/abTestConfigAtom';
import { tracker } from '@/utility/tracking/tracker';
import { PageData, ProductData } from '@/utility/tracking/types';
export type PageTrackerProps = {
  pageData: PageData;
  productData?: ProductData;
};
const PageTracker: React.FC<PageTrackerProps> = t0 => {
  const $ = _c(16);
  const {
    pageData,
    productData
  } = t0;
  const abTest = useOldAbTests();
  const config = useAbTestConfig();
  let t1;
  if ($[0] !== abTest || $[1] !== config.features || $[2] !== pageData || $[3] !== productData) {
    t1 = () => {
      const features = Object.entries(config.features);
      const allAbTests = new Set([...abTest, ...features.map(_temp)]);
      tracker.trackPage({
        pageData: {
          ...pageData,
          abTest: Array.from(allAbTests)
        },
        productData
      });
    };
    $[0] = abTest;
    $[1] = config.features;
    $[2] = pageData;
    $[3] = productData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== abTest || $[6] !== config || $[7] !== pageData || $[8] !== productData) {
    t2 = [pageData, productData, abTest, config];
    $[5] = abTest;
    $[6] = config;
    $[7] = pageData;
    $[8] = productData;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  useEffect(t1, t2);
  let t3;
  if ($[10] !== pageData) {
    t3 = JSON.stringify(pageData);
    $[10] = pageData;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== productData) {
    t4 = JSON.stringify(productData);
    $[12] = productData;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const t5 = `
      window.analytics = window.analytics || {};
      window.analytics.page = ${t3};
      window.analytics.product = ${t4};
    `;
  let t6;
  if ($[14] !== t5) {
    t6 = <script id="initial-page-tracker">{t5}</script>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default PageTracker;
function _temp(t0) {
  const [feature, flag] = t0;
  return `${feature}:${flag}`;
}